import React from 'react';
import { reduxForm, Field } from 'redux-form';
import InputField from '../InputField';
import FormError from '../FormError';
import { formatSaveStatus } from 'helpers/formatters';

let ChangeAttMdn = ({ handleSubmit, error, saveStatus }) => (
  <form onSubmit={handleSubmit}>
    <Field component={InputField} name="mdn" label="MDN" />
    {error && <FormError error={error} />}
    <br />
    <button className="btn btn-default" disabled={saveStatus === 'PENDING'}>
      Update Mdn
    </button>
    <span className="submit-status">{formatSaveStatus(saveStatus)}</span>
  </form>
);

ChangeAttMdn = reduxForm({
  form: 'changeMdn',
})(ChangeAttMdn);

export default ChangeAttMdn;
